import { Injectable, Injector } from "@angular/core";
import { Item } from "@common/ADAPT.Common.Model/organisation/item";
import { Objective } from "@common/ADAPT.Common.Model/organisation/objective";
import { WatcherLink, WatcherLinkAddedBy, WatcherLinkBreezeModel } from "@common/ADAPT.Common.Model/organisation/watcher-link";
import { IAdaptMenuItem } from "@common/ux/menu/menu.component";
import { of, switchMap } from "rxjs";
import { BaseOrganisationService } from "../organisation/base-organisation.service";
import { CurrentWatchersViewComponent } from "./current-watchers-view/current-watchers-view.component";
import { SelectWatcherListComponent } from "./select-watcher-list/select-watcher-list.component";

@Injectable({
    providedIn: "root",
})
export class WatcherService extends BaseOrganisationService {
    public constructor(
        injector: Injector,
    ) {
        super(injector);
    }

    public getItemWatcherMenuEntry(item: Item) {
        return this.getWatcherMenuEntry("item", item);
    }

    public getObjectiveWatcherMenuEntry(objective: Objective) {
        return this.getWatcherMenuEntry("objective", objective);
    }

    private getWatcherMenuEntry(templateInputKey: string, templateData: any) {
        return {
            text: "Watchers",
            icon: "fal fa-fw fa-eye",
            visible: true,
            items: [{
                templateType: CurrentWatchersViewComponent,
                templateId: "current-watchers-view",
                templateInputKey,
                templateData,
                padding: false,
                onClick: (e) => e.event?.stopPropagation(),
            } as IAdaptMenuItem, {
                text: "Add watchers",
                icon: "fal fa-fw fa-plus",
                onClick: (e) => e.event?.stopPropagation(),
                items: [{
                    templateType: SelectWatcherListComponent,
                    templateId: "select-watcher-list",
                    templateInputKey,
                    templateData,
                    onClick: (e) => e.event?.stopPropagation(),
                } as IAdaptMenuItem],
            }],
        } as IAdaptMenuItem;
    }

    public addWatcherLink(personId: number, item?: Item, objective?: Objective) {
        return this.commonDataService.create(WatcherLinkBreezeModel, {
            item,
            objective,
            personId,
            addedBy: WatcherLinkAddedBy.User,
        }).pipe(
            switchMap((watcherLink) => this.commonDataService.saveEntities(watcherLink)),
        );
    }

    public removeWatcherLink(watcherLink: WatcherLink) {
        return this.commonDataService.remove(watcherLink).pipe(
            switchMap((removedEntity) => removedEntity
                // if entity is detached, removedEntity will be undefined
                ? this.commonDataService.saveEntities([removedEntity])
                : of(undefined)),
        );
    }
}
